import forge from 'node-forge'

type SHAType = 'sha1' | 'sha256' | 'sha384' | 'sha512'

interface Options {
  key: string
  shaType?: SHAType
}

export class RSAEncrypt {
  key: string
  shaType: SHAType

  constructor(options: Options) {
    this.key = options.key
    this.shaType = options.shaType || 'sha256'
  }

  encrypt(data: string) {
    const publicKey = forge.pki.publicKeyFromPem(this.key)
    const encrypted = publicKey.encrypt(data, 'RSA-OAEP', {
      md: forge.md[this.shaType].create()
    })

    return forge.util.encode64(encrypted)
  }
}
